import React, { useEffect, useMemo, useRef, useState } from "react";
import PageHeader from "../../components/PageHeader/PageHeader";
import { useLocation, useNavigate } from "react-router";
import CommonTable from "../../components/CommonTable/CommonTable";
import { FaEye, FaTimes } from "react-icons/fa";
// import useTabStore from "../../localStore/useTabStore";
import { get } from "../../Services/ApiHandler";
import { BASE_URL, URLS } from "../../Services/Constant";
import moment from "moment";
import usePermission from "../../customHook/usePermission";
import DateRange from "../../components/DateRange/DateRange";
import axios from "axios";

const DeliveryPartner = () => {
  // const { kv, set } = useTabStore();
  // const orderTab = kv.orderTab || 1;
  const arr = [
    { id: 1, name: "Active Driver" },
    { id: 2, name: "Verification" },
    { id: 3, name: "Rejected" },
    { id: 4, name: "Deactivated" },
  ];

  const location = useLocation();
  const navigate = useNavigate();
  const permission = usePermission();
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [data, setData] = useState([]);
  const [page, setPage] = useState(location?.state?.page || 1);
  const [totalCount, setTotalCount] = useState();
  const [pagination, setPagination] = useState(null);
  const [searchText, setSearchText] = useState("");
  const pageRef = useRef(page);
  const preSearchPageRef = useRef(page);
  const [tab, setTab] = useState(location?.state?.tab || 1);

  const tabRef = useRef(location?.state?.tab || 1);

  const fetchData = async () => {
    try {
      const tabMap = {
        1: "active",
        2: "verification",
        3: "rejected",
        4: "deactivated",
      };

      const tabData = tabMap[tab] || "active";

      const params = new URLSearchParams({
        page: String(page),
        tab: tabData,
        search: searchText || "",
        from_date: fromDate || "",
        to_date: toDate || "",
      });

      const res = await get(`${URLS.DELIVERYPARTNER}?${params.toString()}`);

      if (res?.status === "success") {
        setData(res?.data || []);
        setTotalCount(res?.total_count || 0);

        setPagination({
          current_page: res?.current_page || 1,
          last_page: res?.total_pages || 1,
        });
      }
    } catch (error) {
      console.error("fetchData error:", error);
    }
  };

  useEffect(() => {
    pageRef.current = page;
  }, [page]);

  useEffect(() => {
    if (location?.state?.page) {
      // clear state after using it
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [page, searchText, tab, fromDate, toDate]);

  const handleSelect = (i) => {
    setPage(1);
    pageRef.current = 1;
    setTab(i.id);
    tabRef.current = i?.id;
    // set("orderTab", i?.id);
  };

  const handleView = (i) => {
    if ([1, 4].includes(tab)) {
      navigate("/delivery-partner-view", {
        state: {
          id: i?.id,
          tab: tabRef.current,
          page: page,
          viewData: [1, 4].includes(tab) ? "profile" : "verification",
        },
      });
    } else {
      navigate("/driver-verification", {
        state: {
          id: i?.id,
          tab: tabRef.current,
          page: page,
          viewData: [1, 4].includes(tab) ? "profile" : "verification",
        },
      });
    }
  };

  const columns = useMemo(() => {
    let d = [
      {
        Header: "S.No",
        accessor: "",
        disableSortBy: true,
        width: "1%",
        Cell: ({ row }) => {
          return (
            <span className="sno">
              {String((row?.index || 0) + 1 + (page - 1) * 10).padStart(2, "0")}
            </span>
          );
        },
      },
      {
        Header: "Driver_Id",
        accessor: "driver_id",
        width: "70%",
        Cell: ({ value }) => {
          return <p className="mb-0">{value || "N/A"}</p>;
        },
      },
      {
        Header: "Driver Name",
        accessor: "driver_name",
        width: "70%",
        Cell: ({ value }) => {
          return <p className="mb-0">{value || "N/A"}</p>;
        },
      },
      {
        Header: "Mob_Num",
        accessor: "mobile_number",
        width: "70%",
        Cell: ({ value }) => {
          return <p className="mb-0">{value || "N/A"}</p>;
        },
      },
      {
        Header: "Registration Date",
        accessor: "registered_date",
        width: "70%",
        Cell: ({ value }) => {
          return (
            <p className="mb-0">
              {value ? moment(value).format("DD-MM-YYYY") : "N/A"}
            </p>
          );
        },
      },
      ...(tab === 1
        ? [
            {
              Header: "Status",
              accessor: "status",
              width: "70%",
              Cell: ({ value }) => {
                return <p className="mb-0">{value || "N/A"}</p>;
              },
            },
          ]
        : []),
    ];

    let action = {
      Header: "Action",
      accessor: "action",
      disableSortBy: true,
      width: "20%",
      Cell: ({ row }) => {
        return (
          <>
            {permission?.includes("CAN-VIEW-ORDERS_MANAGEMENT") && (
              <button
                className="action-btn d-flex ac-jc"
                onClick={() => handleView(row?.original)}
              >
                <FaEye />
              </button>
            )}
          </>
        );
      },
    };

    return [...d, action];
  }, [page, tab]);

  const handleClearSearch = () => {
    setSearchText("");
    setPage(preSearchPageRef.current || 1);
  };

  const handleDownload = async () => {
    const token = await localStorage.getItem("token");

    try {
      const response = await axios.get(
        `${BASE_URL}admin/delivery-partners/?search=${searchText || ""}&from_date=${fromDate || ""}&to_date=${toDate || ""}&download=excel`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Kadugudappa_Delivery_Partner_Report.xlsx");
      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  return (
    <div>
      <PageHeader title="Delivery Partner" />
      <div className="d-flex gap-5 mb-5">
        {arr.map((i) => {
          return (
            <button
              onClick={() => handleSelect(i)}
              className={
                tab == i.id ? "header-action-btn" : "header-action-white-btn"
              }
              key={i.id}
            >
              {i.name}
            </button>
          );
        })}
      </div>

      <div
        className="header-row"
        style={{ display: "flex", flexWrap: "wrap", gap: 10, marginBottom: 10 }}
      >
        <h2 className="total-count">Total: {totalCount || 0}</h2>
        <DateRange
          fromDate={fromDate}
          toDate={toDate}
          setFromDate={setFromDate}
          setToDate={setToDate}
        />
        <div
          style={{ display: "flex", alignItems: "center", gap: 5 }}
          className="search-wrapper"
        >
          <button className="export-button" onClick={handleDownload}>
            Export
          </button>
          <input
            type="text"
            placeholder="Search"
            className="search-input"
            value={searchText || ""}
            onChange={(e) => {
              const val = e.target.value;

              if (!searchText && val) {
                preSearchPageRef.current = page || 1;
                setPage(1);
              } else if (searchText && !val) {
                setPage(preSearchPageRef.current || 1);
              }

              setSearchText(val);
            }}
          />
          {searchText && (
            <FaTimes
              className="search-clear-icon"
              onClick={handleClearSearch}
            />
          )}
        </div>
      </div>

      <CommonTable
        columns={columns}
        data={data || []}
        pagecount={pagination}
        setPageno={setPage}
        pageno={page || 1}
      />
    </div>
  );
};

export default DeliveryPartner;
